<template>
  <div class="input">
    <div class="input-label">クイズセット</div>

    <div class="input-group">
      {{ title }}
    </div>
  </div>
</template>

<script>

export default {
  computed: {
    quizset: function () {
      return this.$store.state.eventQuizsetClosed.quizset
    },

    title: function () {
      if (this.quizset) {
        return this.quizset.get('name')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/_form.scss';
</style>
